import { BaseContainerModel } from '../../base-container.model';
import { Bl_inv_stock_replenishment_algo_RowClass } from '../../../dbschema/bl_inv_stock_replenishment_algo.model';

export class StockReplenishmentModel extends BaseContainerModel {
  bl_inv_stock_replenishment_algo: Bl_inv_stock_replenishment_algo_RowClass = new Bl_inv_stock_replenishment_algo_RowClass();
}
